import { Paginator, Message } from '@twilio/conversations';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Input, OnInit, Component, OnDestroy, ElementRef, AfterContentInit } from '@angular/core';

import { SnScrollReference, SnScrollService } from '@lib/common/services';

@Component({
  selector: 'sn-message-scroll',
  templateUrl: './message-scroll.component.html',
  styleUrls: ['./message-scroll.component.scss'],
})
export class SnMessageScrollComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() public fetchFn: () => Observable<Paginator<Message>>;

  private readonly _scrollRef: SnScrollReference;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly _scrollService: SnScrollService,
  ) {
    this._scrollRef = this._scrollService.create(
      'sn-message-scroll',
      this._elementRef.nativeElement,
    );
  }

  public ngOnInit(): void {
    this._scrollRef.loadUp(this.fetchFn).pipe(takeUntil(this._destroy$)).subscribe();
  }

  public ngAfterContentInit(): void {
    const element = this._elementRef.nativeElement;

    if (element.scrollHeight === element.clientHeight) {
      this.fetchFn().pipe(takeUntil(this._destroy$)).subscribe();
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
